import 'babel-polyfill';
import './ie8.js';
/**
 * Import the application module.
 */

import app from './app.module.js';
import pageFooter from './login/footer/esp.pageFooter.js';
import pageHeader from './login/header/esp.pageHeader.js';
import languageSelector from './login/languageselector/languageSelector.js';
import forgotten from './login/forgotten/wai.forgotten.js';
import account  from './login/account/account.wai.js';
import Fingerprint2 from 'fingerprintjs2';

angular.module(app)
  .directive('pageFooter', pageFooter)
  .directive('pageHeader', pageHeader)
  .directive('languageSelector', languageSelector)
  .directive('forgotten', forgotten)
  .directive('account',account)
  .value('useEmailLogin', true)
  .value('whitelabel', 'esp')
  .value('deviceprintFnBmo', Fingerprint2)
  .value('deviceprintFn', Fingerprint2);

/**
 * Import all application styles here.
 */
import './app.esp.less';


// WEBPACK FOOTER //
// ./src/app.esp.js